import { IApplicationState } from '../../types/redux';

export const selectMaxOffersCount = (state: IApplicationState) => {
  return state.listingOffers.maxOffersCount;
};
